class ApiError extends Error {
  constructor(axiosError, ...params) {
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }

    this.name = 'ApiError';
    this.message = axiosError.message;
    this.response = axiosError.response;
    this.date = new Date();
  }
}

export default ApiError;
